// src/services/httpService.ts
import axios from "axios";

const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Function to set the Authorization header when user is logged in
export const setAuthToken = (token: string | null) => {
  if (token) {
    http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete http.defaults.headers.common["Authorization"];
  }
};

// Registered by the auth store; invoked when the backend rejects our session (401),
// so polling loops stop instead of hammering the API with an expired token.
let onUnauthorized: (() => void) | null = null;

export const setOnUnauthorized = (handler: () => void) => {
  onUnauthorized = handler;
};

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      const url = error.config?.url ?? "";
      const isLifecycleTelemetry = url === "/api/v1/projects/lite/upload-lifecycle";
      if (!url.includes("/auth/login") && !isLifecycleTelemetry) {
        onUnauthorized?.();
      }
    }
    return Promise.reject(error);
  }
);

// Export http instance to use in other services
export default http;
